import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {getGuessCoinsType} from '../utils'

export enum JustGameStatusEnum {
  notStarted = 0, // 未开始
  inProgress = 1, // 进行中
  paused = 2, // 暂停
  ended = 3, // 结束
}

// Poup 相关弹窗
export enum JustPoupEnum {
  红包 = 1,
}

export enum JustGameZIndex {
  通用弹窗 = 998,
}

export enum RewardTypeEnum {
  major = 1,
  minor,
  mini,
}

export const RewardStr = {
  [RewardTypeEnum.major]: 'MAJOR',
  [RewardTypeEnum.minor]: 'MINOR',
  [RewardTypeEnum.mini]: 'MINI',
}

export enum wheelEnum {
  nor = 1,
  jack,
}

export enum RankTypeEnum {
  final = 1,
  total = 2,
  daily = 3,
}
// 入口 /live/ground/jt_g_entrance http://wiki.xunlei.cn/pages/viewpage.action?pageId=164418181
export const just_game_entrance = createAsyncThunk(
  'just_game_entrance',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/jt_g_entrance',
      {deviceinfo, game_type: getGuessCoinsType(), from: 'game_page'},
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data
  }
)

// 主页面 http://wiki.xunlei.cn/pages/viewpage.action?pageId=164418204
export const just_game_homepage = createAsyncThunk(
  '/live/ground/jt_g_homepage',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/jt_g_homepage',
      {deviceinfo, game_type: getGuessCoinsType()},
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data
  }
)

// 开宝箱接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=164418207
export const just_game_open_box = createAsyncThunk(
  '/live/ground/jt_g_open_box',
  async (arg: {open_count: number}, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/jt_g_open_box',
      {deviceinfo, game_type: getGuessCoinsType(), ...arg},
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data
    // return {
    //   rewards: [
    //     {
    //       id: 101,
    //       url: 'https://example.com/images/reward1.png',
    //       name: '10元优惠券',
    //       count: 1,
    //     },
    //     {
    //       id: 102,
    //       url: 'https://example.com/images/reward2.png',
    //       name: '100积分',
    //       count: 2,
    //     },
    //   ],
    //   box_count: 0,
    //   miss_hit_cnt: 1,
    //   num_count: 2,
    //   leader_num: 18,
    //   leader_member: {
    //     id: 'u123456',
    //     name: '幸运星',
    //     avatar: 'https://example.com/avatar.png',
    //     score: 1200,
    //   },
    //   countdown: 58,
    //   status: 1,
    //   jackpot: 50000,
    // }
  }
)

// 开钱袋接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=164418212
export const just_game_open_bag = createAsyncThunk(
  '/live/ground/jt_g_open_bag',
  async (arg: {open_count: number}, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/jt_g_open_bag',
      {deviceinfo, game_type: getGuessCoinsType(), ...arg},
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data
  }
)

// 抽奖 http://wiki.xunlei.cn/pages/viewpage.action?pageId=164421764
export const just_game_draw_wheel = createAsyncThunk(
  '/live/ground/jt_g_draw_wheel',
  async (arg: {draw_count: number}, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/jt_g_draw_wheel',
      {deviceinfo, game_type: getGuessCoinsType(), ...arg},
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data

    // 一个一个抽
    return {
      err_msg: '',
      batch_details: [
        // {
        //   bag_number: 1001, // 钱袋号码
        //   bag_balance: 20000, // 钱袋余额
        //   total_reward: 500, // 总奖励
        //   wheel_jackpot_pool: 1500000, // 抽奖后奖池
        //   normal_result: {
        //     hit_id: 2,
        //     reward_coins: 500,
        //     hit_jackpot: false,
        //     jackpot_wheel_id: 0,
        //   },
        //   jackpot_result: null,
        // },
        // {
        //   bag_number: 1002, // 钱袋号码
        //   bag_balance: 20000, // 钱袋余额
        //   total_reward: 500, // 总奖励
        //   wheel_jackpot_pool: 1500000, // 抽奖后奖池
        //   normal_result: {
        //     hit_id: 6,
        //     reward_coins: 500,
        //     hit_jackpot: false,
        //     jackpot_wheel_id: 0,
        //   },
        //   jackpot_result: null,
        // },
        // {
        //   bag_number: 1003, // 钱袋号码
        //   bag_balance: 20000, // 钱袋余额
        //   total_reward: 500, // 总奖励
        //   wheel_jackpot_pool: 1500000, // 抽奖后奖池
        //   normal_result: {
        //     hit_id: 3,
        //     reward_coins: 500,
        //     hit_jackpot: false,
        //     jackpot_wheel_id: 0,
        //   },
        //   jackpot_result: null,
        // },
        {
          bag_number: 1001, // 钱袋号码
          bag_balance: 20000, // 钱袋余额
          total_reward: 500, // 总奖励
          wheel_jackpot_pool: 1500000, // 抽奖后奖池
          normal_result: {
            hit_id: 8,
            reward_coins: 500,
            hit_jackpot: false,
            jackpot_wheel_id: 0,
          },
          jackpot_result: {
            reward_type: 3,
            reward_coins: 8000,
          },
        },
      ],
      summary: {
        normal_reward: 15000,
        mini_jackpot: 50000,
        minor_jackpot: 0,
        major_jackpot: 0,
        total_reward: 15000,
      },
      // summary: null,
    }
  }
)

// 榜单接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=164421764
export const just_game_rank = createAsyncThunk(
  '/live/ground/jt_g_rank',
  async (arg: {type: RankTypeEnum}, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/jt_g_rank',
      {deviceinfo, game_type: getGuessCoinsType(), ...arg},
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data
  }
)

// 钱袋接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=167772750
export const just_game_bag_coins = createAsyncThunk(
  '/live/ground/jt_g_bag_coins',
  async (arg: {count: number}, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/jt_g_bag_coins',
      {deviceinfo, game_type: getGuessCoinsType(), ...arg},
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data
  }
)

export enum BannerTypeEnum {
  start = 1, // 开始时触达
  otherReward = 2, // 其他玩家大奖触达
  totalUser = 3, // 玩家累计用户触达
  gameProcess = 4, // 游戏进程触达
  end = 5, // 活动结束触达
  freshBox = 6, // 刷新宝箱
}

export interface MemberInfo {
  // 2
  id?: number
  name?: string
  avatar?: string
}

export interface PoolInfo {
  pool?: number
}

export interface BulletInfo {
  member_info: MemberInfo
  reward_type: RewardTypeEnum
  reward_coins: number
}

export interface WheelInfoItem {
  id: number
  type: 0 | 1 // 0普通 1jackpot
  odds: number
}
export interface WheelInfo extends PoolInfo {
  bullets: BulletInfo[]
  winner?: {
    member_info: MemberInfo
    coins: number
  }
  targets?: WheelInfoItem[]
}

export interface JackpotInfo extends PoolInfo {
  top?: MemberInfo
  own_rank?: number
  list?: RankItem[]
  own?: RankItem
}

export interface TotalrankInfo extends PoolInfo {
  own_rank?: number
  list?: RankItem[]
  own?: RankItem
}

export interface DailyrankInfo extends PoolInfo {
  own_rank?: number
  list?: RankItem[]
  own?: RankItem
  countdown?: number
  next_day_countdown?: number // 日榜暂停倒计时
}

export interface RankItem {
  member_info: MemberInfo
  rank: number
  latest_time?: string
  coins?: number
  bag_count?: number
}

export enum OtherRewardEnum {}
interface InitialStateType {
  // icon信息
  info: {
    status?: JustGameStatusEnum
    box_count?: number
    is_red?: boolean
    is_in_activity?: boolean // 当前游戏是否参加
    box_guide?: 0 | 1 | 2 // 不展示 展示 已展示
    next_start_countdown?: number // 下期倒计时
  }
  // 横幅信息
  banner: {
    banner_type?: BannerTypeEnum
    countdown?: number // 开始使用
    member_info?: MemberInfo
    reward_coins?: number // 获得的金币数 2
    box_count?: number // 宝箱数量 3
    reward_type?: RewardTypeEnum
  }
  // 主页面更新数据
  homepage: {
    config?: {
      day_start_time: string
      day_end_time: string
      init_time_min: string // 初始时长(min)
      max_time_min: string // 初始时长(min)
      normal_inc_sec: string // 初始时长(s)
    }
    status?: JustGameStatusEnum
    countdown?: number
    fresh_countdown?: boolean // 时间更新标记 只有状态在展示中改变
    next_start_countdown?: number
    total_pool?: number // 总奖池
    jackpot?: JackpotInfo
    wheel?: WheelInfo
    total_rank?: TotalrankInfo
    daily_rank?: DailyrankInfo
    box?: // 宝箱
    {
      box_count: number
      current: number
      target: number
    }
    bag?: {
      bag_count: number
      last_num: number
      coins: number
      speed: string
      open_options: {
        count: number
        coins: number
      }[]
      speed_rules: string[]
      max_open_num: number // 最大可以开启的红包
    }
    fame_star?: {
      mid: number
      avatar: string
    }
  }
  result: {
    batch_details?: {
      bag_number?: number // 钱袋号码
      bag_balance?: number // 钱袋余额
      total_reward?: number // 总奖励
      wheel_jackpot_pool?: number // 抽奖后奖池
      normal_result?: {
        hit_id: number
        reward_coins: number
        hit_jackpot: boolean
        jackpot_wheel_id: number
      }
      jackpot_result?: {
        reward_type: RewardTypeEnum
        reward_coins: number
      }
    }[]
    summary?: {
      normal_reward?: number
      mini_jackpot?: number
      minor_jackpot?: number
      major_jackpot?: number
      mini_time?: number
      minor_time?: number
      major_time?: number
      total_reward?: number
    }
  }
  box_guide: boolean
  showBagOpenGuide?: boolean // 是否展示钱袋引导
  showGetBagFinger?: boolean // 是否展示获取钱袋的小手
}

const initialState: InitialStateType = {
  info: {},
  banner: {
    // banner_type: BannerTypeEnum.end,
    // countdown: 1000, // 开始使用
    // member_info: {},
    // reward_coins: 1000, // 获得的金币数 2
    // box_count: 10000, // 宝箱数量 3
    // reward_type: RewardTypeEnum.major,
  },
  homepage: {},
  result: {},
  box_guide: false,
  showGetBagFinger: false,
}

export const JustGameSlice = createSlice({
  name: 'JustGame',
  initialState,
  reducers: {
    // 更新banner
    updateJustGameBanner: (state, action: PayloadAction<any>) => {
      Object.assign(state.banner, {
        ...action.payload,
      })
      const {box} = state.homepage
      if (action.payload?.banner_type === BannerTypeEnum.freshBox) {
        Object.assign(state.info, {
          is_red: action.payload?.is_red,
          box_count: action.payload?.box_count,
        })
        Object.assign(state.homepage, {
          box: {
            ...(box || {}),
            box_count: action.payload?.box_count,
            target: action.payload?.target ?? box?.target,
            current: action.payload?.current ?? box?.current,
          },
        })
      }
      if (action.payload?.banner_type === BannerTypeEnum.totalUser) {
        Object.assign(state.info, {
          box_count: action.payload?.box_count,
        })
        Object.assign(state.homepage, {
          box: {
            ...(state.homepage.box || {}),
            box_count: action.payload?.box_count,
            target: action.payload?.target ?? box?.target,
            current: action.payload?.current ?? box?.current,
          },
        })
      }
    },
    // 更新主数据
    updateJustGameHomePage: (state, action: PayloadAction<any>) => {
      const {wheel = {}} = action.payload
      Object.assign(state.homepage, {
        ...action.payload,
        wheel: {
          ...state.homepage?.wheel,
          ...action.payload?.wheel,
        },
        jackpot: {
          ...state.homepage?.jackpot,
          ...action.payload?.jackpot,
        },
        daily_rank: {
          ...state.homepage?.daily_rank,
          ...action.payload?.daily_rank,
        },
        total_rank: {
          ...state.homepage?.total_rank,
          ...action.payload?.total_rank,
        },
        fresh_countdown:
          (action.payload?.status ?? state?.homepage?.status) ===
          JustGameStatusEnum.inProgress
            ? !state.homepage?.fresh_countdown
            : state.homepage?.fresh_countdown, // 更新时间
      })
    },
    // deleteBanner
    deleteBanner: (state, action: PayloadAction<any>) => {
      Object.assign(state, {banner: {}})
    },
    updateShowBoxGuide: (state, action: PayloadAction<any>) => {
      Object.assign(state, {box_guide: true})
    },
    setShowBagOpenGuide: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {showBagOpenGuide: action.payload})
    },
    setShowGetBagFinger: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {showGetBagFinger: action.payload})
    },
  },
  extraReducers: (builder) => {
    builder.addCase(just_game_entrance.fulfilled, (state, action) => {
      Object.assign(state.info, {
        ...action.payload,
      })
    })
    builder.addCase(just_game_homepage.fulfilled, (state, action) => {
      Object.assign(state.homepage, {
        ...action.payload,
        // 状态是进行中要展示倒计时更新 -》展示倒计时+逻辑
        fresh_countdown:
          (action.payload?.status ?? state?.homepage?.status) ===
          JustGameStatusEnum.inProgress
            ? !state.homepage?.fresh_countdown
            : state.homepage?.fresh_countdown, // 更新时间
      })
    })
    builder.addCase(just_game_rank.fulfilled, (state, action) => {
      const {type, countdown, daily_countdown, ...res} = action.payload
      switch (type) {
        case RankTypeEnum.final:
          const jackpot = res
          Object.assign(state.homepage, {
            jackpot: {
              ...(state.homepage?.jackpot || {}),
              ...jackpot,
            },
          })
          break
        case RankTypeEnum.total:
          const total_rank = res
          Object.assign(state.homepage, {
            total_rank: {
              ...(state.homepage?.total_rank || {}),
              ...total_rank,
            },
          })
          break
        case RankTypeEnum.daily:
          const daily_rank = res
          Object.assign(state.homepage, {
            daily_rank: {
              ...(state.homepage?.daily_rank || {}),
              ...daily_rank,
              countdown: daily_countdown,
            },
          })
          break
        default:
          break
      }
      Object.assign(state.homepage, {
        countdown,
        fresh_countdown:
          action.payload?.status === JustGameStatusEnum.inProgress
            ? !state.homepage?.fresh_countdown
            : state.homepage?.fresh_countdown, // 更新时间
      })
    })
    builder.addCase(just_game_draw_wheel.fulfilled, (state, action) => {
      const {summary, batch_details} = action.payload
      let mini_time = 0
      let minor_time = 0
      let major_time = 0
      for (let index = 0; index < batch_details?.length; index += 1) {
        const element = batch_details[index]?.jackpot_result?.reward_type
        switch (element) {
          case RewardTypeEnum.major:
            major_time += 1
            break
          case RewardTypeEnum.minor:
            minor_time += 1
            break
          case RewardTypeEnum.mini:
            mini_time += 1
            break
          default:
            break
        }
      }
      Object.assign(state.result, {
        ...action.payload,
        summary: {
          ...summary,
          minor_time,
          major_time,
          mini_time,
        },
      })
    })
  },
})
export function useJustGame() {
  return useSelector((store) => store.Animal_Moose)
}
export default JustGameSlice.reducer
export const JustGameActions = JustGameSlice.actions
